module.exports = __webpack_public_path__ + "img/9.3170c803.png";